document.addEventListener("DOMContentLoaded", function () {
  const scrollButton = document.getElementById("switch-cta-scroll");

  if (!scrollButton) return;

  scrollButton.addEventListener("click", function (e) {
    const href = this.getAttribute("href");

    if (!href || !href.startsWith("#")) return;

    e.preventDefault();

    const purchaseZone =
      document.querySelector("#pf-build-pack") ||
      document.querySelector(".product-information-content") ||
      document.querySelector("#build-starter-pack");

    if (purchaseZone) {
      purchaseZone.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
});